import React, { useState } from "react";
import { PopoverBody, PopoverHeader, Popover } from 'reactstrap';

function TooltipOnhover({labelText = "", titleText = false}) {

  const h1Styles = {
    display: 'block',
    width: 'auto',
    maxWidth: labelText.length * 22 // set the width so the tooltip don't show when hovering outside of the title
  }

  const [showName, setShowName] = useState(false);

  const showNameTooltip = () => {
    setShowName(!showName);
  }
  
  return (<span style={h1Styles}>
    <h1 id="order-name-tooltip">Order: {labelText}</h1>
    <Popover
      flip
      fade
      placement="bottom"
      trigger="hover"
      onMouseOut={showNameTooltip}
      target="order-name-tooltip"
      isOpen={showName}
      toggle={showNameTooltip}
    >
      {titleText && (
        <PopoverHeader>
          {titleText}
        </PopoverHeader>
      )}
      
      <PopoverBody>
        {labelText}
      </PopoverBody>
    </Popover>
  </span>)
}

export default TooltipOnhover;
